module.exports = __webpack_public_path__ + "img/Housse_de_chaise_mariage.18cd076.jpg";